import { render } from "./RGPD.vue?vue&type=template&id=53907402&scoped=true"
import script from "./RGPD.vue?vue&type=script&lang=js"
export * from "./RGPD.vue?vue&type=script&lang=js"

import "./RGPD.vue?vue&type=style&index=0&id=53907402&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53907402"]])

export default __exports__